<!--
/**
 * APCWO customisation for OrangeHRM — Online Users dashboard widget.
 *
 * Licensed under the GNU General Public License v2.0 or later, the same terms
 * as OrangeHRM itself. See the LICENSE file at the project root.
 */
-->

<template>
  <base-widget
    icon="people-fill"
    :loading="isLoading"
    :empty="users.length === 0"
    empty-text="Nobody is online right now"
    :title="`Online Now (${users.length})`"
  >
    <div class="apcwo-online-list">
      <div v-for="u in users" :key="u.empNumber" class="apcwo-online-user">
        <span class="apcwo-online-photo">
          <img
            alt="profile picture"
            :src="`../pim/viewPhoto/empNumber/${u.empNumber}`"
          />
          <span class="apcwo-online-dot" title="Online"></span>
        </span>
        <div class="apcwo-online-details">
          <oxd-text tag="p" class="apcwo-online-name">{{ u.name }}</oxd-text>
          <oxd-text v-if="u.jobTitle" tag="p" class="apcwo-online-title">
            {{ u.jobTitle }}
          </oxd-text>
        </div>
      </div>
    </div>
  </base-widget>
</template>

<script>
import {APIService} from '@/core/util/services/api.service';
import BaseWidget from '@/orangehrmDashboardPlugin/components/BaseWidget.vue';

const REFRESH_MS = 60 * 1000;

export default {
  name: 'OnlineUsersWidget',

  components: {
    'base-widget': BaseWidget,
  },

  setup() {
    const http = new APIService(
      window.appGlobal.baseUrl,
      '/api/v2/apcwo/online-users',
    );
    return {http};
  },

  data() {
    return {
      users: [],
      isLoading: false,
      timer: null,
    };
  },

  beforeMount() {
    this.isLoading = true;
    this.load().finally(() => {
      this.isLoading = false;
    });
    this.timer = setInterval(this.load, REFRESH_MS);
  },

  beforeUnmount() {
    clearInterval(this.timer);
  },

  methods: {
    load() {
      return this.http.getAll().then((response) => {
        this.users = response.data.data;
      });
    },
  },
};
</script>

<style scoped>
.apcwo-online-list {
  max-height: 320px;
  overflow-y: auto;
}
.apcwo-online-user {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  font-size: 12px;
}
.apcwo-online-photo {
  position: relative;
  display: flex;
  flex-shrink: 0;
}
.apcwo-online-photo img {
  width: 36px;
  height: 36px;
  border-radius: 100%;
  box-sizing: border-box;
}
.apcwo-online-dot {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 10px;
  height: 10px;
  border-radius: 100%;
  border: 2px solid #fff;
  background: #2db84d;
}
.apcwo-online-details {
  margin-left: 1rem;
  word-break: break-word;
}
.apcwo-online-name {
  font-weight: 700;
}
.apcwo-online-title {
  font-size: 12px;
}
</style>
